import { render, staticRenderFns } from "./CustomScroll.vue?vue&type=template&id=2b31d799&scoped=true&"
import script from "./CustomScroll.vue?vue&type=script&lang=ts&"
export * from "./CustomScroll.vue?vue&type=script&lang=ts&"
import style0 from "simplebar/dist/simplebar.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./CustomScroll.vue?vue&type=style&index=1&id=2b31d799&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b31d799",
  null
  
)

export default component.exports